const variantInput = document.querySelector('variant-radios');
const pdpFooter = document.getElementById("pdp-footer");
let price = Math.floor(
            (variantInput?.currentVariant?.price 
            ?? document.querySelector('.price')?.dataset.price 
            ?? pdpFooter.dataset.price) / 100);

const zeroInstallmentElement = document.getElementById("zeroInstallmentData");
const zeroInstallment = zeroInstallmentElement?.getAttribute("data-temp");
const zeroInstallmentData = JSON.parse(zeroInstallment);

//Disable the quantity butttons for EPP users
function EPPCalculation() {
    const isB2B = document.getElementById("isB2B");
    const increaseBtn = document.querySelector(".increase-btn svg path");
    const decreaseBtn = document.querySelector(".decrease-btn svg path");

    const EPP_USER = isB2B && isB2B.getAttribute("data-customer-b2b") === "true";

    if (EPP_USER) {
        increaseBtn.style.fill = "#19222A4D";
        increaseBtn.style.fillOpacity = "0.3";
        decreaseBtn.style.fill = "#19222A4D";
        decreaseBtn.style.fillOpacity = "0.3";
        document.querySelector(".increase-btn").style.pointerEvents = "none";
        document.querySelector(".decrease-btn").style.pointerEvents = "none";
    } 
}

EPPCalculation();

function renderPreorderBadge() {
    const tag = document.getElementById("tag");
    if (!tag || !tag.dataset.preordertag || !tag.dataset.preordertag.includes("@")) { return; }
    const preorderDate = parseRawDateToDate(tag.dataset.preordertag.split("@")[1], true);
    tag.innerHTML = "Tersedia mulai " + preorderDate;
}

renderPreorderBadge();

// Observe changes in the 'variant-radios' element
if (variantInput) {
    const observer = new MutationObserver(() => {
        document.querySelector(".quantity-count").textContent = '1'
        updatePrice();
      });
    observer.observe(variantInput, { childList: true, subtree: true, attributes: true });
}

function updatePrice() {
    let price = Math.floor(
        (variantInput?.currentVariant?.price 
        ?? document.querySelector('.price')?.dataset.price 
        ?? pdpFooter.dataset.price) / 100);
    const quantity = parseInt(document.querySelector(".quantity-count").textContent);
    const totalPrice = price * quantity;
    document.querySelector('.original_amt_value').innerHTML = convertToRupiah(totalPrice).slice(0,-3);
    document.getElementById("quantity").value = quantity;
    zeroInstallmentCalculation(totalPrice)
    isStockAvailable()
}

updatePrice();

function convertToRupiah(number, showTrailingZeros = true){
    const showDecimals = showTrailingZeros || !Number.isInteger(number);
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: showDecimals ? 2 : 0
    }).format(number);
}

// Zero Installment Calculation for Footer
function zeroInstallmentCalculation(total_price = price) {
    let highestMonth = 0;
    highestMonth = zeroInstallmentData.reduce((max, block) => {
        if (block.installment_period) {
            return Math.max(max, ...block.installment_period.split(",").map(p => parseInt(p.trim(), 10)));
        }
        return max;
    }, highestMonth);
    let pricePerMonth = total_price/highestMonth
    document.querySelector('.zero_installment_amt').innerHTML = `${convertToRupiah(pricePerMonth,false)} /bulan. untuk ${highestMonth} bulan.`;
}

zeroInstallmentCalculation()

//Stock Availability
function isStockAvailable() {
    const isAvailable = variantInput?.currentVariant?.available;
    const elementsToUpdate = [
        { selector: ".footer-quantity", display: isAvailable ? "flex" : "none" },
        { selector: ".add-to-cart", display: isAvailable ? "flex" : "none" },
        { selector: ".buy-now", display: isAvailable ? "block" : "none" },
        { selector: ".out-of-stock-text", display: isAvailable ? "none" : "block" }
    ];

    elementsToUpdate.forEach(({ selector, display }) => {
        const element = document.querySelector(selector);
        if (element) element.style.display = display;
    });
    return isAvailable;
}

// On Qantity Change
let quantity = 1;

function increaseBtn() {
    const pdpFooter = document.getElementById("pdp-footer");
    const maxQuantity = pdpFooter.dataset.inventory
    let quantityElement = document.querySelector(".quantity-count");
    let quantity = parseInt(quantityElement.textContent);
    if (quantity < maxQuantity) {
        quantity++;
        quantityElement.textContent = quantity;          
        updatePrice();
    }
    updateButtonColors(quantity);
}

function decreaseBtn() {
    let quantityElement = document.querySelector(".quantity-count");
    let quantity = parseInt(quantityElement.textContent);
    if (quantity > 1) {
        quantity--;
        quantityElement.textContent = quantity;
        updatePrice();
    }
    updateButtonColors(quantity);
}

function updateButtonColors(quantity) {
    const maxQuantity = pdpFooter.dataset.inventory;
    const decreaseBtn = document.querySelector(".decrease-btn svg path");
    const increaseBtn = document.querySelector(".increase-btn svg path");
    const activeColor = "#19222A";
    const inactiveColor = "#19222A4D";

    decreaseBtn.style.fill = quantity > 1 ? activeColor : inactiveColor;
    decreaseBtn.style.fillOpacity = quantity > 1 ? "1" : "0.3";

    increaseBtn.style.fill = quantity < maxQuantity ? activeColor : inactiveColor;
    increaseBtn.style.fillOpacity = quantity < maxQuantity ? "1" : "0.3";
}

updateFooterDiscount(variantInput?.currentVariant, true);

function updateFooterDiscount(currentVariant, isInitial = false) {
    const offerAmt = document.querySelector('.offer_amt');
    const originalAmtOff = document.querySelector('.original_amt_off');
    const price = (variantInput?.currentVariant?.price ?? document.querySelector('.price')?.dataset.price ?? pdpFooter.dataset.price);

    if (!offerAmt || !originalAmtOff) return;

    let compareAtPrice = isInitial 
        ? ((currentVariant?.compare_at_price || pdpFooter.dataset.discount) / 100)
        : (currentVariant?.compare_at_price / 100)
    
    let currentPrice = isInitial 
        ? ((currentVariant?.price || price) / 100)
        : (currentVariant?.price / 100)

    if (!isInitial && !currentVariant) return; 

    if (compareAtPrice) {
        offerAmt.innerHTML = convertToRupiah(compareAtPrice).slice(0, -3);
        originalAmtOff.innerHTML = `- ${convertToRupiah(compareAtPrice - currentPrice).slice(0, -3)}`;
        offerAmt.style.display = originalAmtOff.style.display = '';
    } else {
        offerAmt.style.display = originalAmtOff.style.display = 'none';
    }
}
